import React, { useEffect, useState } from "react";
import {
  getExperienceList,
  getTrendingSeasons,
} from "../../../../../queries/queryFunctions/privetQueryFns/getQueryFns";
import { useQuery } from "@tanstack/react-query";
import { usePublicContext } from "../../../../../providers/ReactPublicContextProvider";
import ManageTrendingFilter from "./ManageTrendingFilter";
import ManageTrendingForm from "./ManageTrendingForm";

function ManageTrendingsComponent() {
  const { setIsLoading } = usePublicContext();
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [filterApply, setFilterApply] = useState({});
  const [sites, setSites] = useState([]);
  const { data, isLoading: sitesLoading } = useQuery({
    queryKey: ["sites-list", { ...filterApply, skip, limit }],
    queryFn: getExperienceList,
    options: { keepPreviousData: true },
  });

  const { data: trendingSeasons, isLoading: trendingSeasonsLoading } = useQuery(
    {
      queryKey: ["trending-seasons-list"],
      queryFn: getTrendingSeasons,
    },
  );

  useEffect(() => {
    if (data) {
      const structureData = data[0]?.data?.map((site) => {
        return {
          value: site?._id,
          label: site?.name,
        };
      });
      setSites(structureData);
    }
  }, [data]);

  useEffect(() => {
    setIsLoading(sitesLoading && trendingSeasonsLoading);
  }, [sitesLoading, trendingSeasonsLoading]);

  return (
    <>
      <div class='container mt-5'>
        <div class='card shadow-sm border-0 rounded-4'>
          <div class='card-body p-4'>
            <ManageTrendingFilter setFilterApply={setFilterApply} setSkip={setSkip}/>
            <ManageTrendingForm
              data={data}
              sites={sites}
              trendingSeasons={trendingSeasons}
              limit={limit}
              setLimit={setLimit}
              setSkip={setSkip}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageTrendingsComponent;
